/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // Color name updater for product swatches
document.addEventListener('DOMContentLoaded', function() {
  
  // Function to update color name display
  function updateColorName(input) {
    const colorName = input.getAttribute('data-color-name');
    const swatchContainer = input.closest('[data-swatches-container]');
    
    if (swatchContainer && colorName) {
      const colorNameDisplay = swatchContainer.querySelector('[data-selected-color-name]');
      if (colorNameDisplay) {
        colorNameDisplay.textContent = colorName;
      }
    }
  }

  // Handle swatch inputs (for color swatches)
  const swatchInputs = document.querySelectorAll('.swatch__input[data-color-name]');
  swatchInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (this.checked) {
        updateColorName(this);
      }
    });
  });

  // Handle radio button inputs (for variant option images)
  const radioInputs = document.querySelectorAll('.radio__input[data-color-name]');
  radioInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (this.checked) {
        updateColorName(this);
      }
    });
  });

  // Initialize with currently selected color on page load
  const checkedSwatchInput = document.querySelector('.swatch__input[data-color-name]:checked');
  if (checkedSwatchInput) {
    updateColorName(checkedSwatchInput);
  }

  const checkedRadioInput = document.querySelector('.radio__input[data-color-name]:checked');
  if (checkedRadioInput) {
    updateColorName(checkedRadioInput);
  }
});






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
